import { Button } from "@Light/components/page/Button";
import React from "react";
import { EmailUnsubscribeLayout } from "./EmailUnsubscribeLayout";

export type EmailUnsubscribeScreenProps = {
  /** Lowercase, shown mid-sentence, e.g. "plan savings emails". */
  topicName: string;
  companyName: string;
  email: string;
  topicSubscribed: boolean;
  allSubscribed: boolean;
  pending?: "topic" | "all";
  onToggleTopic: () => void;
  onToggleAll: () => void;
};

export const EmailUnsubscribeScreen: React.FC<EmailUnsubscribeScreenProps> = ({
  topicName,
  companyName,
  email,
  topicSubscribed,
  allSubscribed,
  pending,
  onToggleTopic,
  onToggleAll,
}) => {
  const topicLabel =
    pending === "topic"
      ? topicSubscribed
        ? "Unsubscribing..."
        : "Resubscribing..."
      : topicSubscribed
        ? "Unsubscribe from these emails"
        : "Resubscribe";
  const allLabel =
    pending === "all"
      ? allSubscribed
        ? "Unsubscribing from all emails..."
        : "Resubscribing to all emails..."
      : allSubscribed
        ? "Unsubscribe from all emails"
        : "Resubscribe to all emails";

  return (
    <EmailUnsubscribeLayout
      title={`You're now unsubscribed from ${topicName}`}
      subtitle={`We won't send ${topicName} for ${companyName} electricity plans to ${email} anymore.`}
      actions={
        <>
          <Button
            buttonType="outline"
            size="md"
            className="w-full"
            onClick={onToggleTopic}
            disabled={pending !== undefined}
          >
            {topicLabel}
          </Button>
          <Button
            buttonType="clear"
            size="md"
            className="w-full"
            onClick={onToggleAll}
            disabled={pending !== undefined}
          >
            {allLabel}
          </Button>
        </>
      }
    />
  );
};
